import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

const LoadingBillingDetails = () => (
    <Box>
        <Skeleton animation="wave" variant="rectangular" height={100} sx={{ mb: 2, width: '100%' }} />
        <Skeleton animation="wave" variant="rectangular" height={100} sx={{ mb: 2, width: '100%'}} />
        <Skeleton animation="wave" variant="rectangular" height={100} sx={{ mb: 2, width: '100%'}} />
    </Box>
);

export default LoadingBillingDetails;